// 배송 완료를 막아야 하는 집 판정(화면) — 쉬는 학생·택배 집·남의 담당 집. 서버도 같은 규칙으로 거부한다(functions/src/deliveryGuard.ts)
import type { DongClaim, Student } from "@/types";
import { claimMatchesStudent } from "@/lib/claims";

/**
 * 이 학생을 지금 배송완료로 찍으면 안 되는 이유(기사에게 보여 줄 말). 괜찮으면 "".
 * 관리자는 담당 검사만 건너뛴다(쉼·택배는 관리자도 막는다).
 */
export function deliveryBlockReason(
  s: Pick<Student, "status" | "courierFlag" | "gu" | "dong" | "school">,
  claims: Pick<DongClaim, "scope" | "gu" | "dong" | "school" | "driverUid" | "driverName">[],
  uid: string | undefined,
  isAdmin: boolean,
): string {
  // 「쉼」 버튼은 없앴지만(대표 결정 Q25) 예전에 쉼으로 돌린 학생이 남아 있을 수 있어 검사는 둔다(scripts/pausedStudents.cjs로 정리)
  if (s.status === "paused") return "쉬는 학생입니다(배송을 멈춘 학생). 배송하지 않습니다. 사장님께 확인하세요.";
  if (s.status === "courier" || s.courierFlag) return "택배로 보내는 집입니다. 직접 배송하지 않습니다.";
  if (s.status && s.status !== "active") return "배송 대상이 아닙니다.";
  if (isAdmin) return "";
  const matching = claims.filter((c) => claimMatchesStudent(c, s));
  if (matching.some((c) => c.driverUid === uid)) return "";
  const other = matching.find((c) => c.driverUid && c.driverUid !== uid);
  if (other) return `${other.driverName || "다른"} 기사님 담당 집입니다. 배송하지 않습니다.`;
  return "이번 달 담당으로 고른 동네가 아닙니다. 「담당 선택」에서 고른 뒤 배송하세요.";
}
